<p>
  Jour : {{ parameters.observationDay }}
  <br/>
  <mat-slider min="0" max="1000" step="1" thumbLabel [(value)]="parameters.observationDay"
              (valueChange)="onParameterChange()"></mat-slider>
</p>

<table>
  <tr>
    <th>Planète</th>
    <th>Demi-grand axe <strong>a</strong></th>
    <th>Excentricité <strong>e</strong></th>
    <th>Période de révolution <strong>T</strong></th>
    <th>Moyen mouvement <strong>n</strong></th>
    <th>Anomalie initiale <strong>M<sub>0</sub></strong></th>
    <th>Phase initiale <strong>&omega;<sub>0</sub></strong></th>
  </tr>
  <tr>
    <td>Terre</td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.earth.majorSemiAxis" (change)="onParameterChange()"/>
        <mat-hint>En UA</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.earth.excentricity" (change)="onParameterChange()"/>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.earth.revolutionPeriod" (change)="onParameterChange()"/>
        <mat-hint>En jours</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.earth.averageMovement" (change)="onParameterChange()"/>
        <mat-hint>En rad/j</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.earth.initialAnomaly" (change)="onParameterChange()"/>
        <mat-hint>En rad</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.earth.initialPhase" (change)="onParameterChange()"/>
        <mat-hint>En rad</mat-hint>
      </mat-form-field>
    </td>
  </tr>
  <tr>
    <td>Mars</td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.mars.majorSemiAxis" (change)="onParameterChange()"/>
        <mat-hint>En UA</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.mars.excentricity" (change)="onParameterChange()"/>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.mars.revolutionPeriod" (change)="onParameterChange()"/>
        <mat-hint>En jours</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.mars.averageMovement" (change)="onParameterChange()"/>
        <mat-hint>En rad/j</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.mars.initialAnomaly" (change)="onParameterChange()"/>
        <mat-hint>En rad</mat-hint>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="fill">
        <input matInput [(ngModel)]="parameters.mars.initialPhase" (change)="onParameterChange()"/>
        <mat-hint>En rad</mat-hint>
      </mat-form-field>
    </td>
  </tr>
</table>
